import {
    SET_FILTERS,
    RESET_FILTERS,
    SET_INITIAL_FILTERS,
} from '../actions/types';

import Globals from '../../Globals';
import {
    filterBrands,
    filterModels,
    filterPlate,
    filterDealers,
    filterComercialProducts,
    filterFinancialOperation,
    filterDatePurchaseOptionFrom,
    filterDatePurchaseOptionTo,
} from 'constants/Filters';

import Traductor from 'components/Traductor';

const t = new Traductor();

const initialFiltersState = {
    [Globals.APPLICATION_PATH.AUCTION]: {
        options: {},
        selected: {
            filterAgrupations: [],
            filterBrands: [],
            filterModels: [],
            filterTransmission: [],
            filterEnergies: [],
            filterZones: [],
            filterKm: [],
            filterPowerMax: [],
            filterPriceMax: [],
            filterFavorite: false,
            filterBidden: false,
            filterPlate: '',
            filterRegistrationDate: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 12,
            },
            filterVehiclesBid: [], // Filtro pujados
            upcomingAgrupation: 0,
        },
        initial: {
            filterAgrupations: [],
            filterBrands: [],
            filterModels: [],
            filterTransmission: [],
            filterEnergies: [],
            filterZones: [],
            filterKm: [],
            filterPowerMax: [],
            filterPriceMax: [],
            filterFavorite: false,
            filterBidden: false,
            filterPlate: '',
            filterRegistrationDate: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 12,
            },
            filterVehiclesBid: [], // Filtro pujados
            initPage: 1,
            initCountVehicles: 12,
            upcomingAgrupation: 0,
        },
    },
    [Globals.APPLICATION_PATH.RECEIVINGDEALER]: {
        options: {},
        selected: {
            filterDealers: [],
            filterBrands: [],
            filterModels: [],
            filterComercialProducts: [],
            filterDatePurchaseOptionFrom: null,
            filterDatePurchaseOptionTo: null,
            filterWarrantyExtension: false,
            filterPlate: '',
            filterVIN: '',
            filterFinancialOperation: '',
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
        },
        initial: {
            filterDealers: [],
            filterBrands: [],
            filterModels: [],
            filterComercialProducts: [],
            filterDatePurchaseOptionFrom: null,
            filterDatePurchaseOptionTo: null,
            filterWarrantyExtension: false,
            filterPlate: '',
            filterVIN: '',
            filterFinancialOperation: '',
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
            initPage: 1,
            initCountVehicles: 10,
        },
    },
    [Globals.APPLICATION_PATH.ADJUDICATIONS]: {
        options: {},
        selected: {
            filterBrands: [],
            filterStates: [],
            filterBuyer: [],
            filterPlate: '',
            filterBatch: '',
            filterDatePurchaseFrom: null,
            filterDatePurchaseTo: null,
            filterYearPurchase: [],
            filterMonthPurchase: null,
            filterStadisticsBuyers: [],
            filterTransportState: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
        },
        initial: {
            filterBrands: [],
            filterStates: [],
            filterBuyer: [],
            filterPlate: '',
            filterBatch: '',
            filterDatePurchaseFrom: null,
            filterDatePurchaseTo: null,
            filterYearPurchase: [],
            filterMonthPurchase: null,
            filterStadisticsBuyers: [],
            filterTransportState: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
            initPage: 1,
            initCountVehicles: 10,
        },
    },
    [Globals.APPLICATION_PATH.SOLDVWR]: {
        options: {},
        selected: {
            filterBrands: [],
            filterBuyer: [],
            filterPlate: '',
            filterBatch: '',
            filterDatePurchaseFrom: null,
            filterDatePurchaseTo: null,
            filterYearPurchase: [],
            filterMonthPurchase: null,
            filterStadisticsBuyers: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
        },
        initial: {
            filterBrands: [],
            filterBuyer: [],
            filterPlate: '',
            filterBatch: '',
            filterDatePurchaseFrom: null,
            filterDatePurchaseTo: null,
            filterYearPurchase: [],
            filterMonthPurchase: null,
            filterStadisticsBuyers: [],
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
            initPage: 1,
            initCountVehicles: 10,
        },
    },
    [Globals.APPLICATION_PATH.RENTING_RED_RAC]: {
        options: {
            labels: {
                [filterDealers]: t.getTraduction('Installations'),
                [filterDatePurchaseOptionFrom]: t.getTraduction(
                    'ExpirationDate'
                ),
            },
            availableFilters: {
                advanced: [
                    filterPlate,
                    filterDealers,
                    filterBrands,
                    filterModels,
                    filterDatePurchaseOptionFrom,
                    filterDatePurchaseOptionTo,
                    filterComercialProducts,
                    filterFinancialOperation,
                ],
                principal: [
                    filterPlate,
                    filterDealers,
                    filterBrands,
                    filterModels,
                    filterDatePurchaseOptionFrom,
                    filterDatePurchaseOptionTo,
                ],
            },
            infinite: true,
        },
        selected: {
            filterDealers: [],
            filterBrands: [],
            filterModels: [],
            filterDatePurchaseOptionFrom: null,
            filterDatePurchaseOptionTo: null,
            filterPlate: '',
            filterComercialProducts: [],
            filterFinancialOperation: '',
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
        },
        initial: {
            filterDealers: [],
            filterBrands: [],
            filterModels: [],
            filterDatePurchaseOptionFrom: null,
            filterDatePurchaseOptionTo: null,
            filterPlate: '',
            filterComercialProducts: [],
            filterFinancialOperation: '',
            filterOrder: {
                SelectId: '',
                FieldName: '',
                OrderType: '',
                Page: 1,
                Count: 10,
            },
            initPage: 1,
            initCountVehicles: 10,
        },
    },
};

const filtersReducer = (
    state = initialFiltersState,
    { payload, type, route }
) => {
    if (!route || !type) return state;
    switch (type) {
        case SET_FILTERS:
            return {
                ...state,
                [route]: {
                    ...state[route],
                    selected: payload,
                },
            };
        case SET_INITIAL_FILTERS:
            return {
                ...state,
                [route]: {
                    ...state[route],
                    initial: {
                        ...state[route].initial,
                        ...(payload?.initial || {}),
                    },
                    options: {
                        ...state[route].options,
                        ...(payload?.options || {}),
                    },
                },
            };
        case RESET_FILTERS:
            return {
                ...state,
                [route]: {
                    ...state[route],
                    options: { ...state[route].options, Models: [] },
                    selected: state[route].initial,
                },
            };
        default:
            return state;
    }
};

export default filtersReducer;
